module.exports = __webpack_public_path__ + "img/logo.4ebf7191.svg";